/* esm.sh - applesauce-core@5.2.0/dist/operations/tags */
export * from "/*applesauce-core@5.2.0/esnext/dist/operations/tags.mjs";
